import React, {
    useState,
    useRef,
    useEffect,
} from "react";
import { Link, useNavigate } from 'react-router-dom';

import { faBook } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Tooltip } from "@mui/material";
import { InputName } from "./Input_Name";

import {
    FormControl,
    InputAdornment,
    TextField,
    createStyles,
    makeStyles
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";


export const InputSearch = ({ onSearch, onClear }) => {
    const [term, setTerm] = useState("")
    const [showClearIcon, setShowClearIcon] = useState("none");


    const myInput_e = (e) => {
        setTerm(e.target.value)
        setShowClearIcon(e.target.value === "" ? "none" : "flex");

    }


    const clearSearch = () => {
        // TODO: Clear the search input
        console.log("clicked the clear icon...");
        setTerm("")
        setShowClearIcon("none");
        onClear()

    };

    const myKeyDown_e = (e) => {
        console.log(e)
        console.log(e.Key)
        if (e.key === "Enter") {
            onSearch(term)
        }
    }


    return (
        <TextField
            size="small"
            variant="outlined"
            onChange={myInput_e}
            sx={{ minWidth: 240, maxWidth: 240 }}
            value={term}
            onKeyDown={myKeyDown_e}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon onClick={() => onSearch(term)}
                            />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment
                            position="end"
                            style={{ display: showClearIcon }}
                            onClick={clearSearch}
                        >
                            <ClearIcon />
                        </InputAdornment>
                    )

                }
            }}
        />


    )
}
